// 获取某时间的某周期前时间
export const getPeriodicTime = (paramsTime,periodicTime) => {
  // console.log(paramsTime, "xxxxxxxxxxxx", periodicTime)
  let time = 0
  let targetTime = ''
  let year = 0
  let month = 0
  let day = 0
  switch (periodicTime) {
    case 'day': 
      time = paramsTime - 24 * 60 * 60 * 1000
      year = new Date(time).getFullYear()
      month = new Date(time).getMonth() > 9 ? new Date(time).getMonth() + 1 : '0' + (new Date(time).getMonth() + 1)
      day = new Date(time).getDate() > 10 ? new Date(time).getDate() : '0' + new Date(time).getDate()
      targetTime = year + '-' + month + "-" + day
      return targetTime
    case 'week':
      time = paramsTime - 7 * 24 * 60 * 60 * 1000
      year = new Date(time).getFullYear()
      month = new Date(time).getMonth() > 9 ? new Date(time).getMonth() + 1 : '0' + (new Date(time).getMonth() + 1)
      day = new Date(time).getDate() > 10 ? new Date(time).getDate() : '0' + new Date(time).getDate()
      targetTime = year + '-' + month + "-" + day
      return targetTime
    case 'month':
      time = paramsTime - 30 * 24 * 60 * 60 * 1000
      year = new Date(time).getFullYear()
      month = new Date(time).getMonth() > 9 ? new Date(time).getMonth() + 1 : '0' + (new Date(time).getMonth() + 1)
      day = new Date(time).getDate() > 10 ? new Date(time).getDate() : '0' + new Date(time).getDate()
      targetTime = year + '-' + month + "-" + day
      return targetTime
    case 'year':
      time = paramsTime - 365 * 24 * 60 * 60 * 1000
      year = new Date(time).getFullYear()
      month = new Date(time).getMonth() > 9 ? new Date(time).getMonth() + 1 : '0' + (new Date(time).getMonth() + 1)
      day = new Date(time).getDate() > 10 ? new Date(time).getDate() : '0' + new Date(time).getDate()
      targetTime = year + '-' + month + "-" + day
      return targetTime
  }
}

// 数组去重
export const removeRepeatPropertyFromArray = (arr) => {
  let tempArray = []
  let arrMap = new Map()
  arr.map(item => {
    if (!arrMap.has(item.id)) {
      arrMap.set(item.id,true)
      tempArray.push(item)
    }
  })
  return tempArray
  // const result = Array.from(new Set(arr.map(JSON.stringify)), JSON.parse)
  // return result

}

// // 获取当前时间一周前时间
// export const getWeek = () => {
  
// }

// // 获取当前时间一个月前时间
// export const getMonth = () => {
  
// }

// // 获取当前时间一年前时间
// export const getYear = () => {
  
// }